// Copyright TraderEvolution Global LTD. © 2017-2024. All rights reserved.

export enum ExternalResource {
    HUB = 2,
    SOCOPA = 3,
    OPTIMUS = 6,
    TERRA = 7
}
